import classes from "./Footer.module.css";
import copy from "../images/copy.png";

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.services}>
          <h1>Services</h1>
          <p>Ecommerce</p>
          <p>Online Shopping</p>
        </div>
        <div className={classes.support}>
          <h1>Support</h1>
          <p>FAQs</p>
          <p>Support</p>
        </div>

        <div className={classes.logo}>
          <a target="blank" href="https://www.facebook.com/DCluxurious">
            <i class="fa-brands fa-facebook"></i>
          </a>
          <a
            target="blank"
            href="https://instagram.com/dc_luxurious?igshid=YmMyMTA2M2Y="
          >
            <i class="fa-brands fa-instagram"></i>
          </a>
          <a href="https://wa.me/2348144278102" target="blank">
            <i class="fa-brands fa-whatsapp"></i>
          </a>
          <a
            href="https://twitter.com/Dc_luxurious?t=Zm2nqFXZJUnkdrw-_x7B3w&s=09"
            target="blank"
          >
            <i class="fa-brands fa-twitter"></i>
          </a>
        </div>
      </div>
      <div className={classes.copy}>
        <img alt="copyright" src={copy} />
        <p>DC Luxury 2022. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
